import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';


export const termsandconditionsGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthenticationService);
  const hasAgreedToTerms = authService.getHasAgreedToTerms();
  
  return !hasAgreedToTerms;
};
